<div class="main-container background"></div>